module.exports = __webpack_public_path__ + "static/media/photo1.75276392.jpg";